import React from "react";
import UnsubscriberUserList from "../../../containers/UnsubscriberUserList";

const UnsubscriberUserListPage = () => {
  return (
    <div>
      <UnsubscriberUserList />
    </div>
  );
};

export default UnsubscriberUserListPage;
